import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import React from "react";

interface Props {
  body: React.ReactNode;
  cancelLabel?: string;
  colorScheme: string;
  confirmLabel: string;
  isConfirmDisabled?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  /** A second way to proceed, between Cancel and the confirm button. */
  secondaryLabel?: string;
  title: string;
  onCancel: () => void;
  onConfirm: () => void;
  onSecondary?: () => void;
}

/**
 * Small confirmation dialog used by the review screen (reopen, withdraw, submit, discard and
 * submit on close).
 */
export default function ConfirmDialog(props: Props) {
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isCentered
      closeOnOverlayClick={props.isLoading !== true}
      isOpen={props.isOpen}
      leastDestructiveRef={cancelRef}
      // Room for three buttons in one row
      size={props.secondaryLabel !== undefined ? "xl" : "md"}
      onClose={() => {
        if (props.isLoading !== true) {
          props.onCancel();
        }
      }}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="semibold" pb={2}>
            {props.title}
          </AlertDialogHeader>
          <AlertDialogBody color="gray.700" fontSize="sm">
            {props.body}
          </AlertDialogBody>
          <AlertDialogFooter gap={2}>
            <Button
              ref={cancelRef}
              isDisabled={props.isLoading}
              size="sm"
              variant="ghost"
              onClick={props.onCancel}
            >
              {props.cancelLabel ?? "Cancel"}
            </Button>
            {props.secondaryLabel !== undefined && (
              <Button
                isDisabled={props.isLoading}
                size="sm"
                variant="outline"
                onClick={props.onSecondary}
              >
                {props.secondaryLabel}
              </Button>
            )}
            <Button
              colorScheme={props.colorScheme}
              isDisabled={props.isConfirmDisabled}
              isLoading={props.isLoading}
              size="sm"
              onClick={props.onConfirm}
            >
              {props.confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
